import {Component} from '@angular/core';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-check-policy-management',
  templateUrl: './check-policy-management.component.html',
  styleUrls: ['./check-policy-management.component.css']
})
export class CheckPolicyManagementComponent {
  urlPolicyPortal = environment.policyPortal;
}
